import { CreateOrderRequest, OrderDiscount } from '@models/order';
import { PayloadAction, WritableDraft } from '@reduxjs/toolkit';

export function removeCoupon(
  state: WritableDraft<CreateOrderRequest>,
  action: PayloadAction<string>,
) {
  state.discounts = state.discounts?.filter((d) => d.couponId !== action.payload);
}

export function clearCoupons(state: WritableDraft<CreateOrderRequest>, _: PayloadAction) {
  state.discounts = state.discounts?.filter((d) => d.type !== 'COUPON');
}

export function setDiscounts(
  state: WritableDraft<CreateOrderRequest>,
  action: PayloadAction<OrderDiscount[]>,
) {
  state.discounts = action.payload;
}
